import * as loglevel from 'loglevel';
import safeStringify from 'json-stringify-safe';
import loglevelLocalStorage from './loglevelLocalStorage';

const logConfig = {};

const doBuildLogger = (persistentLog = true) => {
  const {browserLogLevel, level, maxStackSize, key} = logConfig;

  if (!browserLogLevel || !level || !maxStackSize || !key) {
    return;
  }

  // must be called before setLevel
  loglevelLocalStorage(loglevel, {
    level,
    prefix(logSev, ...args) {
      // Stringify for storage in localStorage
      const newArgs = args.map((arg) => (typeof arg === 'object' && !(arg instanceof Date) ? safeStringify(arg) : arg));
      return `[${new Date().toISOString()}] ${logSev}: ${newArgs.join(' ')}`;
    },
    callOriginal: true,
    maxLogStackSize: maxStackSize,
    storeKey: key,
    persistentLog,
  });

  loglevel.setLevel(browserLogLevel);

  console.trace = loglevel.trace;
  console.debug = loglevel.debug;
  console.log = loglevel.log;
  console.info = loglevel.info;
  console.warn = loglevel.warn;
  console.error = loglevel.error;
};

export const buildLogger = (browserLogLevel = 1, level = 1, maxStackSize = 10, key = 'ui_log') => {
  logConfig.browserLogLevel = browserLogLevel;
  logConfig.level = level;
  logConfig.maxStackSize = maxStackSize;
  logConfig.key = key;

  doBuildLogger();

  window.onerror = (msg, url, line) => {
    console.error(`Caught[via window.onerror]: '${msg}' from ${url}:${line}`);

    return false; // same as preventDefault
  };
};

export const getLog = () => {
  const log = window.localStorage.getItem(logConfig.key);

  if (!log) {
    return [];
  }

  return JSON.parse(log);
};

export const clearLog = () => {
  window.localStorage.removeItem(logConfig.key);
};
